import { useContext } from "react";
import AuthContext from "../components/auth-context";
import SGrid from "../components/sgrid";
import PaymentApi from "../api/payment";

function Payments() {
  const context = useContext(AuthContext);
  let dataProvider = (page: number, pageSize: number) =>
    new PaymentApi(context).getAll(page, pageSize);

  return (
    <>
      <div className="card dcard" style={{ padding: "5px" }}>
        <SGrid
          dataProvider={dataProvider}
          columns={[
            ["سریال", "link", 0],
            ["تاریخ ثبت", "date", 1],
            ["مبلغ (ریال)", "rial", 2],
            ["موجودی", "rial", 3],
            ["نوع پرداخت", "farsi", 4],
            ["توضیحات", "description", 5],
          ]}
        />
      </div>
    </>
  );
}

export default Payments;
